<template>
  <div id="page-user-view">
    <vs-alert
      color="danger"
      title="User Not Found"
      :active.sync="user_not_found"
    >
      <span>User record with id: {{ $route.params.id }} not found. </span>
    </vs-alert>

    <div id="user-data" v-if="empData && employeeInformation">
      <vx-card class="mb-base">
        <div class="vx-col w-full">
          <div class="flex items-end px-3 text-primary">
            <feather-icon svgClasses="w-6 h-6" icon="UserIcon" class="mr-2" />
            <span class="font-medium text-xl leading-none text-primary"
              >Employee Account</span
            >
            <!-- NEW: Account Status Toggle Button -->
            <div class="ml-auto flex items-center">
              <span class="mr-3 text-sm font-semibold">Account Status:</span>
              <vs-button
                :color="accountStatusColor"
                :type="accountStatusType"
                size="small"
                @click="toggleAccountStatus"
                :disabled="!isEdit"
              >
                <feather-icon
                  :icon="accountStatusIcon"
                  svgClasses="h-4 w-4 mr-1"
                />
                {{ accountStatusText }}
              </vs-button>
            </div>
          </div>
          <vs-divider />
        </div>
        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <!-- <img :src="empData.photoUrl" class="rounded w-full" /> -->
              <div v-if="empData.photoUrl != ''">
                <img :src="empData.photoUrl" class="rounded w-full" />
              </div>
              <!-- <vs-avatar :src="empData.photoUrl" class="rounded w-full" size="120px" /></div> -->
              <div v-else>
                <vs-avatar
                  class="rounded-full shadow-md cursor-pointer block"
                  size="120px"
                  style="font-size: 50px"
                  :text="empData.fullName"
                  :color="
                    color1 < 12
                      ? 'success'
                      : color1 <= 15
                      ? 'primary'
                      : color1 <= 20
                      ? 'warning'
                      : 'danger'
                  "
                />
              </div>
            </div>
          </div>

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Username</td>
                <td>{{ empData.userName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">
                  Emp No.<span style="color: red">*</span>
                </td>
                <td v-if="isEdit">
                  <vs-input
                    v-validate="'required'"
                    name="employee code"
                    v-model="empData.employeeCode"
                    class="w-full"
                    placeholder="Code"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('employee code')"
                    >{{ errors.first("employee code") }}</span
                  >
                </td>
                <td v-else>{{ empData.employeeCode }}</td>
              </tr>
              <tr>
                <td class="font-semibold">
                  First Name<span style="color: red">*</span>
                </td>
                <td v-if="isEdit">
                  <vs-input
                    v-validate="'required'"
                    name="firstname"
                    v-model="empData.firstName"
                    class="w-full"
                    placeholder="First Name"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('firstname')"
                    >{{ errors.first("firstname") }}</span
                  >
                </td>
                <td v-else>{{ empData.firstName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">
                  Last Name<span style="color: red">*</span>
                </td>
                <td v-if="isEdit">
                  <vs-input
                    v-validate="'required'"
                    name="lastname"
                    v-model="empData.lastName"
                    class="w-full"
                    placeholder="Last Name"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('lastname')"
                    >{{ errors.first("lastname") }}</span
                  >
                </td>
                <td v-else>{{ empData.lastName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">
                  Middle Name<span style="color: red">*</span>
                </td>
                <td v-if="isEdit">
                  <vs-input
                    v-validate="'required'"
                    name="middlename"
                    v-model="empData.middleName"
                    class="w-full"
                    placeholder="Middle Name"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('middlename')"
                    >{{ errors.first("middlename") }}</span
                  >
                </td>
                <td v-else>{{ empData.middleName }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">
                  Email<span style="color: red">*</span>
                </td>
                <td v-if="isEdit">
                  <vs-input
                    v-validate="'required'"
                    name="email"
                    v-model="empData.email"
                    class="w-full"
                    placeholder="Email"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('email')"
                    >{{ errors.first("email") }}</span
                  >
                </td>
                <td v-else>{{ empData.email }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Verified</td>
                <td>
                  <vs-checkbox
                    v-model="empData.emailConfirmed"
                    class="mr-4 mb-2"
                    :disabled="
                      isEdit ? (empData.emailConfirmed ? true : false) : true
                    "
                  ></vs-checkbox>
                </td>
              </tr>
              <tr>
                <td class="font-semibold">
                  Role<span style="color: red">*</span>
                </td>
                <td v-if="isEdit">
                  <v-select
                    name="roles"
                    v-model="roleNameByName"
                    label="name"
                    :options="getAllRoles"
                    class="w-full"
                    placeholder="Please Select"
                  />
                  <!-- <span class="text-danger text-sm" v-show="errors.has('roles')">{{ errors.first('roles') }}</span> -->
                </td>
                <td v-else>{{ roleNameByName.name | capitalize }}</td>
              </tr>
              <tr>
                <td class="font-semibold">
                  Company<span style="color: red">*</span>
                </td>
                <td v-if="isEdit">
                  <v-select
                    name="tenant-name"
                    v-model="tenantName"
                    label="name"
                    :options="getAllTenant"
                  />
                </td>
                <td v-else>{{ tenantName.name }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button
              v-if="!isEdit"
              @click="EditInfo()"
              icon-pack="feather"
              icon="icon-edit"
              class="mr-4"
              >Edit</vs-button
            >
            <vs-button
              v-else
              @click="SaveInfo()"
              icon-pack="feather"
              icon="icon-edit"
              class="mr-4"
              >Save</vs-button
            >
            <vs-button
              v-if="isEdit"
              type="border"
              color="danger"
              icon-pack="feather"
              icon="icon-trash"
              @click="Cancel"
              >Cancel</vs-button
            >
          </div>
        </div>
      </vx-card>

      <div class="vx-row">
        <div class="vx-col lg:w-1/3 w-full">
          <vx-card class="mb-base">
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="flex items-end px-3 text-primary">
                  <feather-icon
                    svgClasses="w-6 h-6"
                    icon="UserIcon"
                    class="mr-2"
                  />
                  <span class="font-medium text-xl leading-none text-primary"
                    >Information</span
                  >
                </div>
                <vs-divider />
              </div>
            </div>
            <table>
              <tr>
                <td class="font-semibold">Gender :</td>
                <td v-if="isEdit">
                  <v-select
                    v-model="genderName"
                    label="gender"
                    :options="getAllGenderLookup"
                    placeholder="Please Select"
                  />
                </td>
                <td v-else>{{ genderName.gender }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Birth Date :</td>
                <td v-if="isEdit">
                  <flatPickr
                    class="w-full"
                    v-model="empData.birthDate"
                    placeholder="Birth Date"
                  />
                </td>
                <td v-else>{{ empData.birthDate | fulldate }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Mobile :</td>
                <td v-if="isEdit">
                  <vs-input
                    v-model="empData.mobileNo"
                    placeholder="11-digit mobile number"
                  />
                </td>
                <td v-else>{{ empData.mobileNo }}</td>
              </tr>
              <tr>
                <td class="font-semibold">
                  Country<span style="color: red">*</span> :
                </td>
                <td v-if="isEdit">
                  <v-select
                    v-validate="'required'"
                    name="country"
                    v-model="countryNames"
                    label="countryName"
                    :options="getAllCountryLookup"
                    placeholder="Please Select"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('country')"
                    >{{ errors.first("country") }}</span
                  >
                </td>

                <td v-else>{{ countryNames.countryName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">
                  Status<span style="color: red">*</span> :
                </td>
                <td v-if="isEdit">
                  <v-select
                    v-validate="'required'"
                    name="status"
                    v-model="empStatusName"
                    label="status"
                    :options="getAllEmpStatus"
                    placeholder="Please Select"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('status')"
                    >{{ errors.first("status") }}</span
                  >
                </td>
                <td v-else>{{ empStatusName.status }}</td>
              </tr>
              <tr>
                <td class="font-semibold">
                  Employment<span style="color: red">*</span> :
                </td>
                <td v-if="isEdit">
                  <v-select
                    v-validate="'required'"
                    name="employment"
                    v-model="employStatusName"
                    label="employStatus"
                    :options="getAllEmploymentStatus"
                    placeholder="Please Select"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('employment')"
                    >{{ errors.first("employment") }}</span
                  >
                </td>
                <td v-else>{{ employStatusName.employStatus }}</td>
              </tr>
              <tr>
                <td class="font-semibold">
                  Date Started<span style="color: red">*</span> :
                </td>
                <td v-if="isEdit">
                  <flatPickr
                    v-validate="'required'"
                    name="date started"
                    class="w-full"
                    v-model="employeeInformation.dateStart"
                    placeholder="Date Start"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('date started')"
                    >{{ errors.first("date started") }}</span
                  >
                </td>
                <td v-else>
                  {{
                    employeeInformation.dateStart != null
                      ? employeeInformation.dateStart
                      : "" | fulldate
                  }}
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Date Resigned :</td>
                <td v-if="isEdit">
                  <flatPickr
                    class="w-full"
                    v-model="employeeInformation.dateResigned"
                    placeholder="Date Resigned"
                  />
                </td>
                <td v-else>
                  {{
                    employeeInformation.dateResigned != null
                      ? employeeInformation.dateResigned
                      : "" | fulldate
                  }}
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Date of Regularization :</td>
                <td v-if="isEdit">
                  <flatPickr
                    class="w-full"
                    v-model="employeeInformation.dateRegularized"
                    placeholder="Regularized Date"
                  />
                </td>
                <td v-else>
                  {{
                    employeeInformation.dateRegularized != null
                      ? employeeInformation.dateRegularized
                      : "" | fulldate
                  }}
                </td>
              </tr>
            </table>
          </vx-card>
        </div>
        <div class="vx-col lg:w-2/3 w-full">
          <vx-card class="mb-base">
            <div class="vx-col w-full">
              <div class="flex items-end px-3 text-primary">
                <feather-icon
                  svgClasses="w-6 h-6"
                  icon="HomeIcon"
                  class="mr-2"
                />
                <span class="font-medium text-xl leading-none text-primary"
                  >Home Address</span
                >
              </div>
              <vs-divider />
            </div>
            <div class="mt-5">
              <!-- <vs-tabs  position="buttom"> -->
              <!-- <vs-tab label="Permanent"  icon-pack="feather" icon="icon-calendar"> -->
              <div class="vx-row">
                <div class="vx-col flex-1" id="account-info-col-1">
                  <table>
                    <tr>
                      <td class="font-semibold">Residential Type</td>
                      <td v-if="isEdit">
                        <v-select
                          v-model="residentialTypeName"
                          label="resType"
                          :options="getAllResidentialTypeLookup"
                          placeholder="Please Select"
                        />
                      </td>
                      <td v-else>{{ residentialTypeName.resType }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Block :</td>
                      <td v-if="isEdit">
                        <vs-input
                          v-model="employeeInformation.permanentBlock"
                          placeholder="Block"
                        />
                      </td>
                      <td v-else>{{ employeeInformation.permanentBlock }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Lot :</td>
                      <td v-if="isEdit">
                        <vs-input
                          v-model="employeeInformation.permanentLot"
                          placeholder="Lot"
                        />
                      </td>
                      <td v-else>{{ employeeInformation.permanentLot }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Phase :</td>
                      <td v-if="isEdit">
                        <vs-input
                          v-model="employeeInformation.permanentPhase"
                          placeholder="Phase"
                        />
                      </td>
                      <td v-else>{{ employeeInformation.permanentPhase }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Street :</td>
                      <td v-if="isEdit">
                        <vs-input
                          v-model="employeeInformation.permanentStreet"
                          placeholder="Street Name"
                        />
                      </td>
                      <td v-else>{{ employeeInformation.permanentStreet }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Address :</td>
                      <td v-if="isEdit">
                        <vs-input
                          v-model="employeeInformation.permanentAddress"
                          placeholder="Home Address"
                        />
                      </td>
                      <td v-else>{{ employeeInformation.permanentAddress }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Brgy :</td>
                      <td v-if="isEdit">
                        <vs-input
                          v-model="employeeInformation.permanentBrgy"
                          placeholder="Barangay"
                        />
                      </td>
                      <td v-else>{{ employeeInformation.permanentBrgy }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">District :</td>
                      <td v-if="isEdit">
                        <vs-input
                          v-model="employeeInformation.permanentDistrict"
                          placeholder="District"
                        />
                      </td>
                      <td v-else>
                        {{ employeeInformation.permanentDistrict }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-semibold">City :</td>
                      <td v-if="isEdit">
                        <vs-input
                          v-model="employeeInformation.permanentCity"
                          placeholder="City"
                        />
                      </td>
                      <td v-else>{{ employeeInformation.permanentCity }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Zip Code :</td>
                      <td v-if="isEdit">
                        <vs-input
                          v-model="employeeInformation.permanentZipCode"
                          placeholder="Zip Code"
                        />
                      </td>
                      <td v-else>{{ employeeInformation.permanentZipCode }}</td>
                    </tr>
                  </table>
                </div>
                <div class="vx-col flex-1" id="account-info-col-2">
                  <table>
                    <tr>
                      <td class="font-semibold">Bldg No. :</td>
                      <td v-if="isEdit">
                        <vs-input
                          v-model="employeeInformation.permanentBldgNo"
                          placeholder="Building No"
                        />
                      </td>
                      <td v-else>{{ employeeInformation.permanentBldgNo }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Floor :</td>
                      <td v-if="isEdit">
                        <vs-input
                          v-model="employeeInformation.permanentFloor"
                          placeholder="Floor"
                        />
                      </td>
                      <td v-else>{{ employeeInformation.permanentFloor }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Room :</td>
                      <td v-if="isEdit">
                        <vs-input
                          v-model="employeeInformation.permanentRoom"
                          placeholder="Room"
                        />
                      </td>
                      <td v-else>{{ employeeInformation.permanentRoom }}</td>
                    </tr>
                  </table>
                </div>
              </div>

              <!-- </vs-tab> -->
              <!-- <vs-tab label="Temporary" icon-pack="feather" icon="icon-calendar">
                        <div class="vx-row">
                            <div class="vx-col flex-1 " id="account-info-col-1">
                                <table>
                                    <tr>
                                        <td class="font-semibold">Block :</td>
                                        <td v-else>{{ employeeInformation.temporaryBlock }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-semibold">Lot :</td>
                                        <td v-else>{{ employeeInformation.temporaryLot }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-semibold">Room :</td>
                                        <td v-else>{{ employeeInformation.temporaryRoom }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-semibold">Bldg No. :</td>
                                        <td v-else>{{ employeeInformation.temporaryBldgNo }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-semibold">Floor :</td>
                                        <td v-else>{{ employeeInformation.temporaryFloor }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-semibold">Phase :</td>
                                        <td v-else>{{ employeeInformation.temporaryPhase }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-semibold">Street :</td>
                                        <td v-else>{{ employeeInformation.temporaryStreet }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-semibold">Address :</td>
                                        <td v-else>{{ employeeInformation.temporaryAddress }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-semibold">Zip Code :</td>
                                        <td v-else>{{ employeeInformation.temporaryZipCode }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-semibold">Brgy  :</td>
                                        <td v-else>{{ employeeInformation.temporaryBrgy }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-semibold">District  :</td>
                                        <td v-else>{{ employeeInformation.temporaryDistrict }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-semibold">City  :</td>
                                        <td v-else>{{ employeeInformation.temporaryCity }}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </vs-tab>
                </vs-tabs> -->
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { en, he } from "vuejs-datepicker/src/locale";

import moment from "moment";
import vSelect from "vue-select";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  data() {
    return {
      empData: null,
      editProfile: null,
      employeeInformation: null,
      user_not_found: false,
      isEdit: false,
    };
  },
  created() {
    this.$vs.loading();
    this.userId = this.$route.params.id;
    this.$store
      .dispatch("lookup/getAllCountryLookup", "timezonedb")
      .catch((err) => {
        console.error(err);
      });
    const payload = {
      pageNumber: 1,
      pageSize: -1,
      sortBy: "CreatedOn",
      sortOrder: "Desc",
    };
    this.$store.dispatch("tenants/getAllTenants", payload).catch((err) => {
      console.error(err);
    });
    this.$store.dispatch("lookup/getAllDepartment").catch((err) => {
      console.error(err);
    });

    this.$store.dispatch("hrms/getAllRoles").catch((err) => {
      console.error(err);
    });

    this.$store
      .dispatch("hrms/getEmployeeByUserId", this.userId)
      .then((res) => {
        this.$vs.loading.close();
        this.empData = JSON.parse(JSON.stringify(res.data));
        console.log(this.empData);
      })
      .catch((err) => {
        this.$vs.loading.close();
        console.log(err);
      });
    this.$store
      .dispatch("hrms/getAllInformation", this.userId)
      .then((res) => {
        this.$vs.loading.close();
        this.employeeInformation = JSON.parse(JSON.stringify(res.data.data));
      })
      .catch((err) => {
        this.$vs.loading.close();
        this.user_not_found = true;
        console.log(err);
      });
  },
  computed: {
    getAllResidentialTypeLookup() {
      return this.$store.state.lookup.residentialType;
    },
    getAllEmpStatus() {
      return this.$store.state.lookup.employeeStatus;
    },
    getAllEmploymentStatus() {
      return this.$store.state.lookup.employmentStatus;
    },
    getAllGenderLookup() {
      return this.$store.state.lookup.gender;
    },
    getAllCountryLookup() {
      return this.$store.state.lookup.getAllCountryLookup;
    },
    getAllRoles() {
      return this.$store.state.hrms.getAllRoles;
    },
    getAllTenant() {
      return this.$store.state.tenants.tenants;
    },
    residentialTypeName: {
      get() {
        return this.$store.getters["lookup/residentialType"](
          this.employeeInformation.residentialType
        );
      },
      set(obj) {
        this.employeeInformation.residentialType = obj.value;
      },
    },
    empStatusName: {
      get() {
        return this.$store.getters["lookup/empStatus"](
          this.employeeInformation.employeeStatus
        );
      },
      set(obj) {
        this.employeeInformation.employeeStatus = obj.value;
      },
    },
    employStatusName: {
      get() {
        return this.$store.getters["lookup/employStatus"](
          this.employeeInformation.employmentStatus
        );
      },
      set(obj) {
        this.employeeInformation.employmentStatus = obj.value;
      },
    },
    genderName: {
      get() {
        return this.$store.getters["lookup/gender"](this.empData.gender);
      },
      set(obj) {
        this.empData.gender = obj.value;
      },
    },
    countryNames: {
      get() {
        return { countryName: this.employeeInformation.country };
      },
      // get() { var country = this.employeeInformation.country !== null ? this.employeeInformation.country : 'Philippines'
      //     return this.$store.getters['lookup/countryLookup'](country)  },
      set(obj) {
        this.employeeInformation.country = obj.countryName;
      },
    },
    tenantName: {
      get() {
        return this.$store.getters["tenants/tenantName"](
          this.empData.tenantsId
        );
      },
      set(obj) {
        this.empData.tenantsId = obj.tenantsId;
      },
    },
    roleNameByName: {
      get() {
        var roleName =
          this.empData.roles.join(", ") !== null
            ? this.empData.roles.join(", ")
            : "User";
        return this.$store.getters["hrms/getRolesByName"](roleName);
      },
      set(obj) {
        this.empData.roles = [obj.name];
      },
    },
    color1() {
      return this.empData.fullName.length;
    },
    accountStatusColor() {
      if (this.empData.accountDisable === 1) return "danger";
      if (this.empData.accountDisable === 0) return "success";
      return "warning"; // for NULL
    },
    accountStatusType() {
      return this.empData.accountDisable === 1 ? "filled" : "border";
    },
    accountStatusText() {
      if (this.empData.accountDisable === 1) return "Disabled";
      if (this.empData.accountDisable === 0) return "Active";
      return "Unknown"; // for NULL
    },
    accountStatusIcon() {
      if (this.empData.accountDisable === 1) return "icon-x-circle";
      if (this.empData.accountDisable === 0) return "icon-check-circle";
      return "icon-help-circle"; // for NULL
    },
  },

  methods: {
    EditInfo() {
      this.isEdit = true;
      this.editProfile = this.empData;
      this.empData = this.editProfile;
    },
    SaveInfo() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading();
          this.isEdit = false;
          this.$store
            .dispatch("hrms/disableEmployee", this.empData.id)
            .then((res) => {})
            .catch((err) => console.log(err));
          this.$store
            .dispatch("hrms/UpdateUserProfile", this.empData)
            .then((res) => {})
            .catch((err) => console.log(err));
          this.$store
            .dispatch("hrms/UpdateInformation", this.employeeInformation)
            .then((res) => {
              this.$vs.loading.close();
              this.$vs.notify({
                title: "Success",
                text: "Employee Information Updated",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
              });
            })
            .catch((error) => {
              this.$vs.loading.close();
              this.$vs.notify({
                title: "Error",
                text: error.message,
                iconPack: "feather",
                icon: "icon-x-octagon",
                color: "danger",
              });
            });
        } else {
          this.$vs.notify({
            title: "Error",
            text: error.message,
            iconPack: "feather",
            icon: "icon-x-octagon",
            color: "danger",
          });
        }
      });
    },
    Cancel() {
      this.isEdit = false;
    },
    toggleAccountStatus() {
      // Cycle through states: NULL/Unknown -> Active (0) -> Disabled (1) -> Active (0)
      if (
        this.empData.accountDisable === null ||
        this.empData.accountDisable === undefined
      ) {
        this.empData.accountDisable = 0; // Set to Active
      } else if (this.empData.accountDisable === 0) {
        this.empData.accountDisable = 1; // Set to Disabled
      } else {
        this.empData.accountDisable = 0; // Set to Active
      }
    },
  },
  components: {
    "v-select": vSelect,
    Datepicker,
    flatPickr,
  },
};
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 10px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
</style>
